var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWraning = function SvgWraning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.613 10.63c.518 0 .938.42.938.937v6.25a.937.937 0 1 1-1.875 0v-6.25c0-.517.42-.937.937-.937ZM15.606 20.63a.938.938 0 0 0 0 1.875h.011a.937.937 0 1 0 0-1.875h-.01Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.46 28.017H8.038c-2.375 0-4.29-.856-5.247-2.486-.957-1.629-.772-3.72.377-5.793l3.9-7.026 3.675-6.6c1.205-2.17 2.933-3.492 4.87-3.492 1.938 0 3.665 1.32 4.87 3.492l7.575 13.638c1.15 2.074 1.33 4.166.372 5.794-.957 1.629-2.872 2.486-5.242 2.486h-7.575a.947.947 0 0 1-.153-.013Zm.153-23.522c-1 0-2.21.687-3.23 2.527l-3.675 6.6-3.9 7.025c-.95 1.715-.91 3.067-.4 3.935.509.867 1.667 1.56 3.63 1.56h7.575c.052 0 .104.005.154.013h7.421c1.956 0 3.116-.693 3.626-1.561.511-.87.554-2.221-.396-3.934L18.844 7.023c-1.02-1.84-2.231-2.528-3.23-2.528Z",
    fill: "currentColor"
  })));
};
export default SvgWraning;